import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';

import AdminStaffPageHeader from './components/AdminStaffPageHeader';
import AdminStaffTableContainer from './components/AdminStaffTableContainer';

interface FilterTerms {
  searchTerm: string;
  isArrangeByLastName: boolean;
  loginEnabled: string;
}

const AdminStaffPage = (): JSX.Element => {
  const initialSearchFiltersValue = {
    searchTerm: '',
    isArrangeByLastName: false,
    loginEnabled: '',
    isActive: 'true',
  };
  const [searchFilters, setSearchFilters] = useState<FilterTerms>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<FilterTerms>(searchFilters, 250);

  return (
    <>
      <AdminStaffPageHeader
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
      />

      <AdminStaffTableContainer searchFilters={debouncedSearchFilters} />
    </>
  );
};

export default AdminStaffPage;
